import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5858 2C14.0573 2 14.5116 2.16649 14.8702 2.46691L15 2.58579L19.4142 7C19.7476 7.3334 19.9511 7.77238 19.9923 8.23836L20 8.41421V20C20 21.0544 19.1841 21.9182 18.1493 21.9945L18 22H6C4.94564 22 4.08183 21.1841 4.00549 20.1493L4 20V4C4 2.94564 4.81588 2.08183 5.85074 2.00549L6 2H13.5858ZM12 4H6V20H18V10H13.5C12.6716 10 12 9.32843 12 8.5V4ZM14 4.41421V8H17.5858L14 4.41421Z",
		fill: "currentColor"
	})
});
export default SvgFileLine;
